/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DataGroupedByAxis } from '../models/data-grouped-by-axis';
import { DataStatsGroupedByAxis } from '../models/data-stats-grouped-by-axis';
import { EventLogEntryList } from '../models/event-log-entry-list';
import { EventLogFieldGroupList } from '../models/event-log-field-group-list';
import { EventLogFilterEntryList } from '../models/event-log-filter-entry-list';
import { exportHistoricalAnalogicData } from '../fn/historical-data/export-historical-analogic-data';
import { ExportHistoricalAnalogicData$Params } from '../fn/historical-data/export-historical-analogic-data';
import { exportHistoricalEventData } from '../fn/historical-data/export-historical-event-data';
import { ExportHistoricalEventData$Params } from '../fn/historical-data/export-historical-event-data';
import { getEventsLog } from '../fn/historical-data/get-events-log';
import { getEventsLog$Any } from '../fn/historical-data/get-events-log-any';
import { GetEventsLog$Any$Params } from '../fn/historical-data/get-events-log-any';
import { GetEventsLog$Params } from '../fn/historical-data/get-events-log';
import { getEventsLogByGroup } from '../fn/historical-data/get-events-log-by-group';
import { getEventsLogByGroup$Any } from '../fn/historical-data/get-events-log-by-group-any';
import { GetEventsLogByGroup$Any$Params } from '../fn/historical-data/get-events-log-by-group-any';
import { GetEventsLogByGroup$Params } from '../fn/historical-data/get-events-log-by-group';
import { getEventsLogGroups } from '../fn/historical-data/get-events-log-groups';
import { getEventsLogGroups$Any } from '../fn/historical-data/get-events-log-groups-any';
import { GetEventsLogGroups$Any$Params } from '../fn/historical-data/get-events-log-groups-any';
import { GetEventsLogGroups$Params } from '../fn/historical-data/get-events-log-groups';
import { getHistoricalData } from '../fn/historical-data/get-historical-data';
import { GetHistoricalData$Params } from '../fn/historical-data/get-historical-data';
import { getHistoricalDataStats } from '../fn/historical-data/get-historical-data-stats';
import { GetHistoricalDataStats$Params } from '../fn/historical-data/get-historical-data-stats';
import { getTags } from '../fn/historical-data/get-tags';
import { getTags$Any } from '../fn/historical-data/get-tags-any';
import { GetTags$Any$Params } from '../fn/historical-data/get-tags-any';
import { GetTags$Params } from '../fn/historical-data/get-tags';
import { getTagsByGroup } from '../fn/historical-data/get-tags-by-group';
import { getTagsByGroup$Any } from '../fn/historical-data/get-tags-by-group-any';
import { GetTagsByGroup$Any$Params } from '../fn/historical-data/get-tags-by-group-any';
import { GetTagsByGroup$Params } from '../fn/historical-data/get-tags-by-group';
import { getTagsGroups } from '../fn/historical-data/get-tags-groups';
import { GetTagsGroups$Params } from '../fn/historical-data/get-tags-groups';
import { GraphTagGroupList } from '../models/graph-tag-group-list';
import { GraphTagList } from '../models/graph-tag-list';
import { searchEventLogStation } from '../fn/historical-data/search-event-log-station';
import { searchEventLogStation$Any } from '../fn/historical-data/search-event-log-station-any';
import { SearchEventLogStation$Any$Params } from '../fn/historical-data/search-event-log-station-any';
import { SearchEventLogStation$Params } from '../fn/historical-data/search-event-log-station';


/**
 * All about historical data
 */
@Injectable({ providedIn: 'root' })
export class HistoricalDataService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getEventsLog()` */
  static readonly GetEventsLogPath = '/stations/{uid}/eventslog/search';

  /**
   * get the eventLog of a given station.
   *
   * get the eventLog of a given station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEventsLog()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getEventsLog$Response(params: GetEventsLog$Params, context?: HttpContext): Observable<StrictHttpResponse<EventLogEntryList>> {
    return getEventsLog(this.http, this.rootUrl, params, context);
  }

  /**
   * get the eventLog of a given station.
   *
   * get the eventLog of a given station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEventsLog$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getEventsLog(params: GetEventsLog$Params, context?: HttpContext): Observable<EventLogEntryList> {
    return this.getEventsLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<EventLogEntryList>): EventLogEntryList => r.body)
    );
  }

  /**
   * get the eventLog of a given station.
   *
   * get the eventLog of a given station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEventsLog$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getEventsLog$Any$Response(params: GetEventsLog$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<EventLogEntryList>> {
    return getEventsLog$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * get the eventLog of a given station.
   *
   * get the eventLog of a given station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEventsLog$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getEventsLog$Any(params: GetEventsLog$Any$Params, context?: HttpContext): Observable<EventLogEntryList> {
    return this.getEventsLog$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<EventLogEntryList>): EventLogEntryList => r.body)
    );
  }

  /** Path part for operation `searchEventLogStation()` */
  static readonly SearchEventLogStationPath = '/stations/{uid}/eventslogfilter/search';

  /**
   * get the eventLog of a given station.
   *
   * get the eventLog of a given station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchEventLogStation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchEventLogStation$Response(params: SearchEventLogStation$Params, context?: HttpContext): Observable<StrictHttpResponse<EventLogFilterEntryList>> {
    return searchEventLogStation(this.http, this.rootUrl, params, context);
  }

  /**
   * get the eventLog of a given station.
   *
   * get the eventLog of a given station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchEventLogStation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchEventLogStation(params: SearchEventLogStation$Params, context?: HttpContext): Observable<EventLogFilterEntryList> {
    return this.searchEventLogStation$Response(params, context).pipe(
      map((r: StrictHttpResponse<EventLogFilterEntryList>): EventLogFilterEntryList => r.body)
    );
  }

  /**
   * get the eventLog of a given station.
   *
   * get the eventLog of a given station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchEventLogStation$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchEventLogStation$Any$Response(params: SearchEventLogStation$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<EventLogFilterEntryList>> {
    return searchEventLogStation$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * get the eventLog of a given station.
   *
   * get the eventLog of a given station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchEventLogStation$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchEventLogStation$Any(params: SearchEventLogStation$Any$Params, context?: HttpContext): Observable<EventLogFilterEntryList> {
    return this.searchEventLogStation$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<EventLogFilterEntryList>): EventLogFilterEntryList => r.body)
    );
  }

  /** Path part for operation `getEventsLogGroups()` */
  static readonly GetEventsLogGroupsPath = '/stations/{uid}/eventslog/group';

  /**
   * Get the group list of eventLog for a given station.
   *
   * get the grouped eventLog of a given station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEventsLogGroups()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getEventsLogGroups$Response(params: GetEventsLogGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<EventLogFieldGroupList>> {
    return getEventsLogGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the group list of eventLog for a given station.
   *
   * get the grouped eventLog of a given station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEventsLogGroups$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getEventsLogGroups(params: GetEventsLogGroups$Params, context?: HttpContext): Observable<EventLogFieldGroupList> {
    return this.getEventsLogGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<EventLogFieldGroupList>): EventLogFieldGroupList => r.body)
    );
  }

  /**
   * Get the group list of eventLog for a given station.
   *
   * get the grouped eventLog of a given station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEventsLogGroups$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getEventsLogGroups$Any$Response(params: GetEventsLogGroups$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<EventLogFieldGroupList>> {
    return getEventsLogGroups$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the group list of eventLog for a given station.
   *
   * get the grouped eventLog of a given station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEventsLogGroups$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getEventsLogGroups$Any(params: GetEventsLogGroups$Any$Params, context?: HttpContext): Observable<EventLogFieldGroupList> {
    return this.getEventsLogGroups$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<EventLogFieldGroupList>): EventLogFieldGroupList => r.body)
    );
  }

  /** Path part for operation `getEventsLogByGroup()` */
  static readonly GetEventsLogByGroupPath = '/stations/{uid}/eventslog/group/search';

  /**
   * Get the list of eventLog for a group for a given station.
   *
   * get the eventLog for a group for a given station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEventsLogByGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getEventsLogByGroup$Response(params: GetEventsLogByGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<EventLogEntryList>> {
    return getEventsLogByGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the list of eventLog for a group for a given station.
   *
   * get the eventLog for a group for a given station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEventsLogByGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getEventsLogByGroup(params: GetEventsLogByGroup$Params, context?: HttpContext): Observable<EventLogEntryList> {
    return this.getEventsLogByGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<EventLogEntryList>): EventLogEntryList => r.body)
    );
  }

  /**
   * Get the list of eventLog for a group for a given station.
   *
   * get the eventLog for a group for a given station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEventsLogByGroup$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getEventsLogByGroup$Any$Response(params: GetEventsLogByGroup$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<EventLogEntryList>> {
    return getEventsLogByGroup$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the list of eventLog for a group for a given station.
   *
   * get the eventLog for a group for a given station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEventsLogByGroup$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getEventsLogByGroup$Any(params: GetEventsLogByGroup$Any$Params, context?: HttpContext): Observable<EventLogEntryList> {
    return this.getEventsLogByGroup$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<EventLogEntryList>): EventLogEntryList => r.body)
    );
  }

  /** Path part for operation `getTags()` */
  static readonly GetTagsPath = '/stations/{uid}/graph/tags/search';

  /**
   * Get the tags to be used for the graph view.
   *
   * The tags to be shown in the graphs for a station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTags$Response(params: GetTags$Params, context?: HttpContext): Observable<StrictHttpResponse<GraphTagList>> {
    return getTags(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the tags to be used for the graph view.
   *
   * The tags to be shown in the graphs for a station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTags(params: GetTags$Params, context?: HttpContext): Observable<GraphTagList> {
    return this.getTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<GraphTagList>): GraphTagList => r.body)
    );
  }

  /**
   * Get the tags to be used for the graph view.
   *
   * The tags to be shown in the graphs for a station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTags$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getTags$Any$Response(params: GetTags$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<GraphTagList>> {
    return getTags$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the tags to be used for the graph view.
   *
   * The tags to be shown in the graphs for a station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTags$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getTags$Any(params: GetTags$Any$Params, context?: HttpContext): Observable<GraphTagList> {
    return this.getTags$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<GraphTagList>): GraphTagList => r.body)
    );
  }

  /** Path part for operation `getTagsGroups()` */
  static readonly GetTagsGroupsPath = '/stations/{uid}/graph/tags/group';

  /**
   * Get the groups of tags.
   *
   * The groups of tags
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTagsGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTagsGroups$Response(params: GetTagsGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<GraphTagGroupList>> {
    return getTagsGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the groups of tags.
   *
   * The groups of tags
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTagsGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTagsGroups(params: GetTagsGroups$Params, context?: HttpContext): Observable<GraphTagGroupList> {
    return this.getTagsGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<GraphTagGroupList>): GraphTagGroupList => r.body)
    );
  }

  /** Path part for operation `getTagsByGroup()` */
  static readonly GetTagsByGroupPath = '/stations/{uid}/graph/tags/group/search';

  /**
   * Get the tags of a given group.
   *
   * The groups of a given group
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTagsByGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTagsByGroup$Response(params: GetTagsByGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<GraphTagList>> {
    return getTagsByGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the tags of a given group.
   *
   * The groups of a given group
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTagsByGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTagsByGroup(params: GetTagsByGroup$Params, context?: HttpContext): Observable<GraphTagList> {
    return this.getTagsByGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<GraphTagList>): GraphTagList => r.body)
    );
  }

  /**
   * Get the tags of a given group.
   *
   * The groups of a given group
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTagsByGroup$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getTagsByGroup$Any$Response(params: GetTagsByGroup$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<GraphTagList>> {
    return getTagsByGroup$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the tags of a given group.
   *
   * The groups of a given group
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTagsByGroup$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getTagsByGroup$Any(params: GetTagsByGroup$Any$Params, context?: HttpContext): Observable<GraphTagList> {
    return this.getTagsByGroup$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<GraphTagList>): GraphTagList => r.body)
    );
  }

  /** Path part for operation `getHistoricalData()` */
  static readonly GetHistoricalDataPath = '/stations/{uid}/graph/historical';

  /**
   * Get bucketed historical data on the given station.
   *
   * Allows to get a set of historical data on the given station, for the given date interval and given tags. Moreover the data is delivered according to a given time step type and range (f.i. every 10 hours), using a given calculation function to apply on the set of values of each time interval (f.i. average)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHistoricalData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getHistoricalData$Response(params: GetHistoricalData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DataGroupedByAxis>>> {
    return getHistoricalData(this.http, this.rootUrl, params, context);
  }

  /**
   * Get bucketed historical data on the given station.
   *
   * Allows to get a set of historical data on the given station, for the given date interval and given tags. Moreover the data is delivered according to a given time step type and range (f.i. every 10 hours), using a given calculation function to apply on the set of values of each time interval (f.i. average)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHistoricalData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getHistoricalData(params: GetHistoricalData$Params, context?: HttpContext): Observable<Array<DataGroupedByAxis>> {
    return this.getHistoricalData$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DataGroupedByAxis>>): Array<DataGroupedByAxis> => r.body)
    );
  }

  /** Path part for operation `getHistoricalDataStats()` */
  static readonly GetHistoricalDataStatsPath = '/stations/{uid}/graph/historical/stats';

  /**
   * Get historical data stats on the given station.
   *
   * Allows to get a set of historical data stats on the given station, for the given date interval and given tags. You can also retrieve those stats in the getHistoricalData endpoint with the withStats option. This enpoint allows to retrieve only the stats.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHistoricalDataStats()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getHistoricalDataStats$Response(params: GetHistoricalDataStats$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DataStatsGroupedByAxis>>> {
    return getHistoricalDataStats(this.http, this.rootUrl, params, context);
  }

  /**
   * Get historical data stats on the given station.
   *
   * Allows to get a set of historical data stats on the given station, for the given date interval and given tags. You can also retrieve those stats in the getHistoricalData endpoint with the withStats option. This enpoint allows to retrieve only the stats.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHistoricalDataStats$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getHistoricalDataStats(params: GetHistoricalDataStats$Params, context?: HttpContext): Observable<Array<DataStatsGroupedByAxis>> {
    return this.getHistoricalDataStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DataStatsGroupedByAxis>>): Array<DataStatsGroupedByAxis> => r.body)
    );
  }

  /** Path part for operation `exportHistoricalAnalogicData()` */
  static readonly ExportHistoricalAnalogicDataPath = '/stations/{uid}/data/historical/analogic/export';

  /**
   * Export in Excel the historical analogic data for a given station.
   *
   * Export in Excel the historical analogic data for a given station, in a given interval, and sorted on a given field and direction
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportHistoricalAnalogicData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportHistoricalAnalogicData$Response(params: ExportHistoricalAnalogicData$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportHistoricalAnalogicData(this.http, this.rootUrl, params, context);
  }

  /**
   * Export in Excel the historical analogic data for a given station.
   *
   * Export in Excel the historical analogic data for a given station, in a given interval, and sorted on a given field and direction
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportHistoricalAnalogicData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportHistoricalAnalogicData(params: ExportHistoricalAnalogicData$Params, context?: HttpContext): Observable<Blob> {
    return this.exportHistoricalAnalogicData$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `exportHistoricalEventData()` */
  static readonly ExportHistoricalEventDataPath = '/stations/{uid}/data/historical/event/export';

  /**
   * Export in Excel the historical event data for a given station.
   *
   * Export in Excel the historical event data for a given station, in a given interval, and sorted on a given field and direction
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportHistoricalEventData()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportHistoricalEventData$Response(params: ExportHistoricalEventData$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportHistoricalEventData(this.http, this.rootUrl, params, context);
  }

  /**
   * Export in Excel the historical event data for a given station.
   *
   * Export in Excel the historical event data for a given station, in a given interval, and sorted on a given field and direction
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportHistoricalEventData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportHistoricalEventData(params: ExportHistoricalEventData$Params, context?: HttpContext): Observable<Blob> {
    return this.exportHistoricalEventData$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
